import { getOwaWorkload } from 'owa-workloads';
import { getPerformanceEntryForResourceAsync } from 'mini-performance/lib/utils/resourcePerformanceObserver';
import { getResourcesForWorkload } from './utils/getResourcesForWorkload';
import { isGulpingValue } from 'owa-querystring';

export interface WorkloadLoadInfo {
    /** Workload exclusive resource download duration */
    werdd: number;

    /** Workload exclusive resource transfer size */
    werts: number;

    /** Workload exclusive decoded body size */
    werdbs: number;
}

/**
 * This method returns the duration of a workload exclusive file
 * by tracking load of it using perf observer
 * This will help in analytics where duration and transfer size can be used to decide if
 * it was served from cache or not.
 */
export async function getWorkloadKeyResourceDWInfo(): Promise<WorkloadLoadInfo> {
    const workload = getOwaWorkload();
    const resourceLoadEntry = {} as WorkloadLoadInfo;

    if (!isGulpingValue) {
        const fileToCheck = getResourcesForWorkload(workload);
        const workloadPerformanceTimingEntry = await getPerformanceEntryForResourceAsync(
            fileToCheck
        );

        if (workloadPerformanceTimingEntry) {
            Object.assign(resourceLoadEntry, {
                /** Workload exclusive resource download duration */
                werdd: workloadPerformanceTimingEntry.duration,

                /** Workload exclusive resource transfer size */
                werts: workloadPerformanceTimingEntry.transferSize,

                /** Workload exclusive decoded body size */
                werdbs: workloadPerformanceTimingEntry.decodedBodySize,
            });
        }
    }

    return Promise.resolve(resourceLoadEntry);
}
